// extracted by mini-css-extract-plugin
export default {"secondaryGrey400":"#9CA3AF","formContainer":"invite_single_user_formContainer__BT6gh","backIcon":"invite_single_user_backIcon__pLKbN"};